@switch (type) {
    <!-- BASIC -->
    @case (MatButtonAvailableType.BASIC) {
        <button
            mat-button
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            @if (iconName) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ label }}
        </button>
    }
    <!-- RAISED -->
    @case (MatButtonAvailableType.RAISED) {
        <button
            mat-raised-button
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            @if (iconName) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ label }}
        </button>
    }
    <!-- STROKED -->
    @case (MatButtonAvailableType.STROKED) {
        <button
            mat-stroked-button
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            @if (iconName) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ label }}
        </button>
    }
    <!-- FLAT -->
    @case (MatButtonAvailableType.FLAT) {
        <button
            mat-flat-button
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            @if (iconName) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ label }}
        </button>
    }
    <!-- ICON -->
    @case (MatButtonAvailableType.ICON) {
        <button
            mat-icon-button
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- No content possible with ICON button -->
        </button>
    }
    <!-- FAB -->
    <!-- FAB button can be extended -->
    @case (MatButtonAvailableType.FAB) {
        <button
            mat-fab
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            [extended]="fabExtended"
            (click)="copy(tooltip)">
            <!-- FAB button always needs to have an icon -->
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- Content only possible when the button is extended -->
            @if (fabExtended) {
                {{ label }}
            }
        </button>
    }
    <!-- MINI_FAB -->
    @case (MatButtonAvailableType.MINI_FAB) {
        <button
            mat-mini-fab
            [color]="AMColor"
            [class]="class"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : label"
            (click)="copy(tooltip)">
            <!-- FAB_MINI button always needs to have an icon -->
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- No content possible with MINI_FAB button -->
        </button>
    }
}
<mat-tooltip
    #tooltip="matTooltip"
    matTooltip="{{ 'shared.tooltip.copied' | translate }}"></mat-tooltip>
